import React from "react";

import { Spinner } from "react-bootstrap";

export const Loading = () => (
  <div className="w-100 d-flex justify-content-center">
    <Spinner animation="border" role="status">
      <span className="visually-hidden">Loading...</span>
    </Spinner>
  </div>
);
